import FloatingButton from "./FloatingButton";

import whatsappIcon from "../../assets/icon/ic_baseline-whatsapp.svg";
import linkIcon from "../../assets/icon/tabler_link-filled.svg";

export default function FloatingContactButtons() {
  return (
    <div
      className="
        fixed

        right-6
        bottom-8

        z-50

        flex
        flex-col

        gap-4
      ">
      <FloatingButton
        icon={whatsappIcon}
        alt="WhatsApp"
        href="https://wa.me/628123456789"
      />
{/* 
      <FloatingButton
        icon={linkIcon}
        alt="Portfolio"
        href="https://arunika.co.id"
      /> */}
    </div>
  );
}
